export const IS_BTF_ALREADY_USED_FOR_CMT = 'mac/FETCH_IS_BTF_ALREADY_USED_FOR_CMT';
export const MANAGE_APP_LINK_FOR_BTF_UNDER_CMT = 'mac/FETCH_MANAGE_APP_LINK_FOR_BTF_UNDER_CMT';
export const SITE_NAME_WITH_DOMAIN_FOR_BTF_UNDER_CMT =
  'mac/FETCH_SITE_NAME_WITH_DOMAIN_FOR_BTF_UNDER_CMT';
